import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateOrUpdateNoiseEventPolicyOverride } from 'app/__generated__/global';
import { createOrUpdateNoiseEventPolicyOverride } from 'app/business-logic/services/noise-service/createOrUpdateNoiseEventPolicyOverride';
import { invalidateNoiseEventQueries } from '../events-listing/invalidateNoiseEventQueries';

export const useUpdateNoiseEventPolicyOverride = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (params: CreateOrUpdateNoiseEventPolicyOverride) => {
      return createOrUpdateNoiseEventPolicyOverride(params);
    },
    onSuccess: () => {
      invalidateNoiseEventQueries(queryClient);
    },
  });
  return { mutateAsync, isPending };
};
